import { render } from "./CustomerBookingsView.vue?vue&type=template&id=6e67dc2e&ts=true&lang=pug"
import script from "./CustomerBookingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerBookingsView.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__